import Vue from 'vue'
import Vuex from 'vuex'
import global from '@/store/global'
import devMnt from '@/store/devMnt'
import groupMnt from '@/store/groupMnt'
import devSel from '@/store/devSelect'
import productInfo from '@/store/productInfo'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: global.state,
  getters: global.getters,
  mutations: global.mutations,
  actions: global.actions,
  modules: {
    devMnt,
    devSel,
    groupMnt,
    productInfo
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js